import React, { useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import defaults from '../../translations/en.json';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },
  viewer: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
  },
  pageWrap: {
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
}));

type FaxPdfBlobViewerProps = {
  file: Blob;
  maxPageWidth?: number;
};

export const FaxPdfBlobViewer = ({
  file,
  maxPageWidth,
}: FaxPdfBlobViewerProps) => {
  const classes = useStyles();
  const [numPages, setNumPages] = useState<number | null>(null);

  const pageWidth = useMemo(() => {
    if (maxPageWidth != null) return maxPageWidth;
    if (typeof window === 'undefined') return 640;
    return Math.min(880, window.innerWidth - 48);
  }, [maxPageWidth]);

  return (
    <div className={classes.root}>
      <div className={classes.viewer}>
        <Document
          file={file}
          onLoadSuccess={({ numPages: n }) => setNumPages(n)}
          loading={<span>{defaults.loadingPdf}</span>}
          error={<span>{defaults.pdfLoadError}</span>}
        >
          {numPages != null &&
            Array.from({ length: numPages }, (_, i) => (
              <div key={i + 1} className={classes.pageWrap}>
                <Page pageNumber={i + 1} width={pageWidth} />
              </div>
            ))}
        </Document>
      </div>
    </div>
  );
};
